export default {
  "auth.login": "로그인",
  "auth.register": "회원가입",
  "auth.email": "이메일 주소",
  "auth.password": "비밀번호",
  "auth.logout": "로그아웃",
  "auth.loginFailed": "로그인에 실패했습니다",
  "auth.registerFailed": "사용자 등록에 실패했습니다",
  "nav.dashboard": "평가 대시보드",
  "nav.activeEvaluations": "진행 중인 평가",
  "nav.completedEvaluations": "완료된 평가",
  "nav.createNew": "새로운 평가 생성",
  "nav.projectMerge": "프로젝트 통합",
  "nav.share": "공유 설정",
  "nav.copy": "복사",
  "nav.delete": "삭제",
  "nav.settings": "설정",
  "menu.language": "언어 설정",
  "status.inProgress": "진행 중",
  "status.completed": "완료",
  "status.untitled": "제목 없는 평가",
  "stats.subjects": "대상",
  "stats.criteria": "관점",
  "stats.progress": "진행률",
  "step.criteriaExtraction": "평가 관점 추출",
  "step.comparison": "좋은 순서대로 배열해 봅시다",
  "step.subjectRegistration": "평가 대상 등록",
  "form.evaluationPolicy": "평가 방침",
  "form.policyDescription": "평가 방침 및 중점 사항",
  "form.policyPlaceholder": "예: 논리적 구성을 중시하고 창의성과 독창성을 평가하고 싶음",
  "btn.aiExtraction": "AI 관점 추출",
  "btn.manualAdd": "관점 수동 추가",
  "btn.next": "다음",
  "btn.back": "뒤로",
  "plan.free": "무료 플랜",
  "plan.professional": "프로페셔널",
  "plan.business": "비즈니스",
  "plan.school": "학교",
  "plan.unlimitedProjects": "무제한 프로젝트",
  "plan.prioritySupport": "우선 지원",
  "plan.dataExport": "데이터 내보내기",
  "plan.monthlyRenewal": "매월 자동 갱신",
  "plan.cancelAnytime": "언제든지 취소 가능",
  "plan.paymentFailed": "결제 시작에 실패했습니다",
  "confirm.delete": "삭제하시겠습니까? 이 작업은 취소할 수 없습니다",
  "alert.appUpdate": "애플리케이션 업데이트가 감지되었습니다",
  "alert.projectLimit": "평가 프로젝트 생성 한도에 도달했습니다",
  "common.loading": "로딩 중...",
  "common.save": "저장",
  "common.cancel": "취소",
  "common.confirm": "확인",
  "common.error": "오류",
  "common.success": "성공",
  "date.today": "오늘",
  "date.yesterday": "어제",
  "date.thisWeek": "이번 주",
  "date.lastWeek": "지난 주",
  "error.dashboardLoad": "대시보드 로딩 오류",
  "error.serverUnavailable": "서버에 연결할 수 없습니다. 나중에 다시 시도해 주세요",
  "error.evaluationLimit": "평가 제한 확인에 실패했습니다",
  "error.loadingData": "로딩 오류",
  "error.copyFailed": "복사 오류",
  "error.deleteFailed": "삭제에 실패했습니다",
  "error.copyProcess": "복사 과정에서 오류가 발생했습니다",
  "error.deleteProcess": "삭제 과정에서 오류가 발생했습니다",
  "error.sharingUpdate": "공유 설정 업데이트에 실패했습니다",
  "msg.loadingDashboard": "대시보드 로딩 중...",
  "msg.retry": "재시도",
  "msg.projectLimitReached": "평가 프로젝트 생성 한도에 도달했습니다",
  "msg.upgradeToProPlan": "PRO 플랜으로 업그레이드하세요",
  "msg.cannotCreateProject": "평가 프로젝트를 생성할 수 없습니다",
  "msg.freeLastProject": "무료 플랜은 최대 1개의 평가 프로젝트를 허용합니다. 이것이 마지막 사용 가능한 슬롯입니다.",
  "msg.untitledProject": "제목 없는 평가 프로젝트",
  "msg.welcome": "환영합니다",
  "msg.created": "생성됨",
  "msg.updated": "업데이트됨",
  "msg.completed": "완료됨",
  "copy.title": "{{title}}의 복사본을 생성합니다.",
  "copy.newTitle": "새 제목을 입력하세요 (공백으로 두면 \"원본 제목 (복사본)\"이 됩니다)",
  "progress.completed": "완료",
  "common.initializing": "애플리케이션 초기화 중...",
  "common.connecting": "연결 중...",
  "common.processing": "처리 중...",
  "common.required": "필수",
  "common.close": "닫기",
  "common.preview": "미리보기",
  "common.edit": "편집",
  "common.details": "세부사항",
  "common.position": "위치",
  "common.rank": "순위",
  "common.placed": "배치됨",
  "common.characters": "문자",
  "common.items": "항목",
  "common.folders": "폴더",
  "common.files": "파일",
  "common.openInNewTab": "새 탭에서 열기",
  "common.next": "다음",
  "common.prev": "이전",
  "googleDrive.title": "Google Drive에서 가져오기",
  "googleDrive.connect": "Google Drive에 연결",
  "googleDrive.description": "Google Drive에서 평가 대상을 일괄 가져오려면 먼저 Google 계정으로 로그인하세요.",
  "googleDrive.signIn": "Google 계정으로 로그인",
  "modal.closeModal": "모달 닫기",
  "invitation.invalid": "잘못된 초대 토큰",
  "invitation.accepted": "초대를 수락했습니다",
  "invitation.failed": "초대 수락에 실패했습니다",
  "invitation.title": "평가 프로젝트 초대",
  "invitation.accept": "초대 수락",
  "collaboration.viewResults": "평가 결과 보기",
  "collaboration.addComments": "댓글 추가",
  "collaboration.downloadData": "데이터 다운로드",
  "collaboration.editCriteria": "평가 기준 편집",
  "collaboration.manageProject": "프로젝트 관리",
  "autoSave.settings": "자동 저장 설정",
  "autoSave.interval": "저장 간격",
  "autoSave.15seconds": "15초",
  "autoSave.30seconds": "30초",
  "autoSave.1minute": "1분",
  "autoSave.2minutes": "2분",
  "autoSave.5minutes": "5분",
  "autoSave.saveNow": "지금 저장",
  "autoSave.saved": "저장됨",
  "autoSave.helpShort": "짧은 간격으로 자주 저장",
  "autoSave.helpMedium": "균형 있는 저장 빈도",
  "autoSave.helpLong": "긴 간격으로 리소스 절약",
  "weight.title": "전체 평가 가중치 설정",
  "weight.description": "각 평가 기준에 대한 가중치를 설정하세요. 전체 가중치는 100%로 조정됩니다.",
  "weight.equalDistribution": "균등 분배",
  "weight.criterion": "평가 기준",
  "weight.weight": "가중치 (%)",
  "weight.maxScore": "최고 점수",
  "weight.saveSettings": "설정 저장",
  "preview.title": "{{title}} 미리보기",
  "preview.iframeBlocked": "일부 사이트는 iframe 내에서의 표시를 차단할 수 있습니다.",
  "preview.showPreview": "미리보기 표시",
  "preview.editDetails": "세부사항 편집",
  "preview.available": "미리보기 가능",
  "googleDrive.myDrive": "내 드라이브",
  "googleDrive.emptyFolder": "이 폴더는 비어있습니다",
  "googleDrive.filesSelected": "개 파일 선택됨",
  "googleDrive.importSelected": "선택된 파일 가져오기",
  "dashboard.projectLimitReached": "평가 프로젝트 생성 한도에 도달했습니다 ({count}개 프로젝트). PRO 플랜으로 업그레이드하세요.",
  "dashboard.cannotCreateProject": "평가 프로젝트를 생성할 수 없습니다.",
  "dashboard.freeLastProject": "무료 플랜은 최대 1개의 평가 프로젝트를 허용합니다. 이것이 마지막 사용 가능한 슬롯입니다.",
  "dashboard.evaluationLimitCheckFailed": "평가 제한 확인에 실패했습니다.",
  "dashboard.loadingError": "로딩 오류: {{message}}",
  "dashboard.copyError": "복사 오류: {{message}}",
  "dashboard.copyProcessError": "복사 과정에서 오류가 발생했습니다",
  "dashboard.deleteError": "삭제 오류: {{message}}",
  "dashboard.deleteProcessError": "삭제 과정에서 오류가 발생했습니다",
  "dashboard.shareSettingsUpdateFailed": "공유 설정 업데이트에 실패했습니다",
  "dashboard.copyProjectTitle": "{{title}}의 복사본을 생성합니다.",
  "dashboard.copyProjectPrompt": "새 제목을 입력하세요 (공백으로 두면 \"원본 제목 (복사본)\"이 됩니다):",
  "dashboard.deleteConfirm": "{{title}}을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "dashboard.statusUnknown": "알 수 없음",
  "dashboard.collaborators": "{{count}}명의 협력자",
  "dashboard.menu": "메뉴",
  "dashboard.shareSettings": "공유 설정",
  "dashboard.copy": "복사",
  "dashboard.delete": "삭제",
  "dashboard.subjects": "대상",
  "dashboard.criteria": "기준",
  "dashboard.progress": "진행률",
  "dashboard.completed": "완료",
  "dashboard.created": "생성됨:",
  "dashboard.updated": "업데이트됨:",
  "dashboard.loadingDashboard": "대시보드 로딩 중...",
  "dashboard.retry": "재시도",
  "dashboard.title": "평가 대시보드",
  "dashboard.projectMerge": "프로젝트 통합",
  "dashboard.createNew": "새로운 평가 생성",
  "dashboard.inProgressTab": "진행 중인 평가",
  "dashboard.completedTab": "완료된 평가",
  "dashboard.noInProgress": "진행 중인 평가가 없습니다",
  "dashboard.noInProgressDesc": "새로운 평가를 생성하여 시작해보세요.",
  "dashboard.noCompleted": "완료된 평가가 없습니다",
  "dashboard.noCompletedDesc": "완료된 평가가 여기에 표시됩니다.",
  "dashboard.untitledProject": "제목 없는 평가 프로젝트",
  "dashboard.sharing": "공유 중",
  "billing.paymentCompleted": "결제 완료",
  "billing.subscriptionCompleted": "구독 등록이 완료되었습니다. 서비스를 이용해 주셔서 감사합니다!",
  "billing.paymentCanceled": "결제가 취소되었습니다. 다시 시도하거나 문의해 주세요.",
  "settings.backToDashboard": "← 대시보드로 돌아가기",
  "userSettings.title": "사용자 설정",
  "userSettings.description": "계정 정보 및 보안 설정을 관리합니다.",
  "userSettings.basicInfo": "기본 정보",
  "userSettings.username": "사용자명",
  "userSettings.usernamePlaceholder": "사용자명 입력",
  "userSettings.email": "이메일 주소",
  "userSettings.emailPlaceholder": "example@domain.com",
  "userSettings.displayName": "표시 이름",
  "userSettings.displayNamePlaceholder": "표시 이름 입력 (선택사항)",
  "userSettings.displayNameHelp": "다른 사용자에게 표시되는 이름입니다.",
  "userSettings.saving": "저장 중...",
  "userSettings.saveSettings": "설정 저장",
  "userSettings.securitySettings": "보안 설정",
  "userSettings.securityMode": "보안 모드",
  "userSettings.securityModeDescription": "개인정보 보호를 위해 데이터 암호화를 활성화합니다.",
  "userSettings.securityOn": "활성화됨",
  "userSettings.securityOff": "비활성화됨",
  "userSettings.securityCode": "보안 코드",
  "userSettings.hide": "숨기기",
  "userSettings.show": "표시",
  "userSettings.encryptionCode": "암호화 코드",
  "userSettings.recoveryCode": "복구 코드",
  "userSettings.copy": "복사",
  "userSettings.generateNewKeys": "새 키 생성",
  "userSettings.manualKeyInput": "수동 키 입력",
  "userSettings.viewSharedData": "공유 데이터 보기",
  "userSettings.viewSharedDataDescription": "다른 사용자가 공유한 암호화된 데이터를 보려면 키를 입력하세요.",
  "userSettings.inputEncryptionKey": "암호화 키 입력",
  "userSettings.manualKeyTitle": "수동 암호화 키 입력",
  "userSettings.manualKeyDescription": "공유된 암호화 키 쌍을 입력하세요.",
  "userSettings.publicKey": "공개 키",
  "userSettings.publicKeyPlaceholder": "공개 키 입력",
  "userSettings.privateKey": "개인 키",
  "userSettings.privateKeyPlaceholder": "개인 키 입력",
  "userSettings.keyWarning": "경고:",
  "userSettings.keyWarningText": "이 키들은 기밀입니다. 안전한 장소에 보관하세요.",
  "userSettings.setKeys": "키 설정",
  "userSettings.requiredFieldsError": "사용자명과 이메일 주소는 필수 필드입니다.",
  "userSettings.enableSecurityModeConfirm": "보안 모드를 활성화하시겠습니까? 데이터 암호화가 시작됩니다.",
  "userSettings.securityModeEnabled": "보안 모드가 활성화되었습니다.",
  "userSettings.securityModeDisabled": "보안 모드가 비활성화되었습니다.",
  "userSettings.generateNewKeysConfirm": "새 키를 생성하시겠습니까? 기존 키는 무효화됩니다.",
  "userSettings.newKeysGenerated": "새 키가 생성되었습니다.",
  "userSettings.bothKeysRequired": "공개 키와 개인 키 모두 필요합니다.",
  "userSettings.invalidPublicKeyFormat": "공개 키 형식이 올바르지 않습니다.",
  "userSettings.invalidPrivateKeyFormat": "개인 키 형식이 올바르지 않습니다.",
  "userSettings.keysSet": "키가 설정되었습니다.",
  "userSettings.keySetError": "키 설정 중 오류가 발생했습니다.",
  "userSettings.copiedToClipboard": "클립보드에 복사되었습니다.",
  "userSettings.copyFailed": "복사에 실패했습니다.",
  "billing.currentPlan": "현재 플랜",
  "billing.status.developerAccess": "개발자 액세스",
  "billing.status.active": "활성",
  "billing.status.free": "무료",
  "billing.nextRenewalDate": "다음 갱신일",
  "billing.autoRenewalNote": "(자동으로 청구됨)",
  "billing.expiresAt": "만료일",
  "billing.cancelNotice": "이 구독은 현재 기간 종료 시 취소됩니다.",
  "billing.cancelSubscription": "구독 취소",
  "billing.cancelSubscriptionConfirm": "구독을 취소하시겠습니까? 현재 기간 종료 시 취소됩니다.",
  "billing.cancelSubscriptionSuccess": "구독 취소가 처리되었습니다. 현재 기간 종료 시 취소됩니다.",
  "billing.cancelSubscriptionFailed": "취소에 실패했습니다.",
  "billing.forIndividual": "(개인용)",
  "billing.forBusiness": "(비즈니스용)",
  "billing.forSchool": "(학교용)",
  "billing.free": "무료",
  "billing.month": "월",
  "billing.year": "년",
  "billing.features": "기능",
  "billing.upgrade": "업그레이드",
  "billing.customQuote": "맞춤 견적",
  "billing.flexibleCustomization": "유연한 맞춤화 지원",
  "billing.educationalDiscount": "교육 기관 특별 가격",
  "billing.requestCorporateQuote": "기업 견적 요청",
  "billing.requestAcademicQuote": "학술 견적 요청",
  "billing.aboutBilling": "청구에 대하여",
  "billing.autoRenewal": "자동 갱신",
  "billing.autoRenewalDescription": "월간 플랜은 매월 같은 날 자동으로 갱신됩니다",
  "billing.nextRenewalDateDescription": "현재 구독자는 위의 \"현재 플랜\" 섹션에서 확인할 수 있습니다",
  "billing.cancellation": "취소",
  "billing.cancellationDescription": "언제든지 취소 가능하며, 현재 기간 종료 시 서비스가 중단됩니다",
  "billing.payment": "결제",
  "billing.paymentDescription": "Stripe의 안전한 결제 시스템을 사용합니다",
  "billing.receipt": "영수증",
  "billing.receiptDescription": "결제 완료 후 이메일로 자동 발송됩니다",
  "billing.aiUsageLimitation": "AI 사용 제한 안내",
  "billing.enterprise": "비즈니스용",
  "billing.education": "교육용",
  "billing.feature.limited_projects": "최대 3개 프로젝트",
  "billing.feature.unlimited_projects": "무제한 프로젝트",
  "billing.feature.unlimited_collaborators": "무제한 협력자",
  "billing.feature.basic_rubric": "기본 평가 기준 기능",
  "billing.feature.advanced_rubric": "고급 평가 기준 기능",
  "billing.feature.ai_assistance": "AI 지원 기능",
  "billing.feature.priority_support": "우선 지원",
  "billing.feature.data_export": "데이터 내보내기",
  "billing.feature.custom_templates": "사용자 정의 템플릿",
  "billing.feature.pdf_export": "PDF 내보내기",
  "billing.feature.limited_pdf_export": "PDF 내보내기 (하루 5건 제한)",
  "billing.feature.no_csv_export": "CSV 내보내기: 이용 불가",
  "billing.feature.allProfessionalFeatures": "모든 프로페셔널 플랜 기능",
  "billing.feature.unlimitedUsers": "무제한 사용자 수",
  "billing.feature.dedicatedSupportAgent": "전담 지원 에이전트",
  "billing.feature.customIntegrationAPI": "맞춤 통합 및 API 개발",
  "billing.feature.customBranding": "맞춤 브랜딩 지원",
  "billing.feature.singleSignOn": "Single Sign-On (SSO)",
  "billing.feature.auditLogSecurity": "감사 로그 및 보안 기능",
  "billing.feature.onPremiseDeployment": "온프레미스 배포 지원",
  "billing.feature.trainingImplementationSupport": "교육 및 구현 지원",
  "billing.feature.unlimitedStudentFacultyAccounts": "무제한 학생 및 교직원 계정",
  "billing.feature.educationalInstitutionSpecialPricing": "교육 기관 특별 가격",
  "billing.feature.classroomPracticalTemplates": "교실 및 실습 템플릿",
  "billing.feature.gradeManagementSystemIntegration": "성적 관리 시스템 통합",
  "billing.feature.learningAnalyticsReporting": "학습 분석 및 보고",
  "billing.feature.parentGuardianSharingFeature": "학부모 및 보호자 공유 기능",
  "billing.feature.educationalInstitutionDedicatedSupport": "교육 기관 전담 지원",
  "billing.feature.implementationTrainingTeacherTraining": "구현 교육 및 교사 연수",
  "quote.title": "엔터프라이즈 플랜 견적 요청",
  "quote.submit": "견적 요청",
  "quote.sections.contactInfo": "담당자 정보",
  "quote.sections.usagePlan": "이용 계획",
  "quote.sections.budgetRequirements": "예산 및 요구사항",
  "quote.fields.name": "성명",
  "quote.fields.position": "직책",
  "quote.fields.phone": "전화번호",
  "quote.fields.expectedUsers": "예상 이용자 수",
  "quote.fields.timeline": "도입 희망 시기",
  "quote.fields.useCase": "이용 목적·용도",
  "quote.fields.currentSolution": "현재 평가 방법·도구",
  "quote.fields.budget": "예산 범위",
  "quote.fields.requirements": "필요한 기능·요구사항",
  "quote.fields.message": "기타 요청·질문",
  "quote.placeholders.currentSolution": "현재 사용 중인 평가 방법이나 도구가 있다면 알려주세요",
  "quote.placeholders.message": "기타 요청이나 질문이 있으시면 알려주세요",
  "quote.timeline.immediate": "즉시",
  "quote.timeline.oneMonth": "1개월 이내",
  "quote.timeline.threeMonths": "3개월 이내",
  "quote.timeline.sixMonths": "6개월 이내",
  "quote.timeline.oneYear": "1년 이내",
  "quote.timeline.undecided": "미정",
  "quote.success.title": "견적 요청을 접수했습니다",
  "quote.error.submitFailed": "견적 요청 전송에 실패했습니다",
  "quote.error.submitFailedRetry": "견적 요청 전송에 실패했습니다. 잠시 후 다시 시도해 주세요.",
  "common.pleaseSelect": "선택해주세요",
  "common.other": "기타",
  "common.submitting": "전송 중...",
  "quote.corporate.subtitle": "기업 대상",
  "quote.corporate.description": "귀하의 요구사항에 맞춘 맞춤형 엔터프라이즈 솔루션을 제안해 드립니다. 아래 양식을 작성하시고 언제든지 문의해 주세요.",
  "quote.corporate.sections.companyInfo": "회사 정보",
  "quote.corporate.fields.companyName": "회사명",
  "quote.corporate.fields.department": "부서명",
  "quote.corporate.userCounts.small": "10~50명",
  "quote.corporate.userCounts.medium": "51~100명",
  "quote.corporate.userCounts.large": "101~300명",
  "quote.corporate.userCounts.xlarge": "301~500명",
  "quote.corporate.userCounts.xxlarge": "501~1,000명",
  "quote.corporate.userCounts.enterprise": "1,000명 이상",
  "quote.corporate.budget.under500k": "월 50만원 미만",
  "quote.corporate.budget.500k1m": "월 50~100만원",
  "quote.corporate.budget.1m3m": "월 100~300만원",
  "quote.corporate.budget.3m5m": "월 300~500만원",
  "quote.corporate.budget.over5m": "월 500만원 이상",
  "quote.corporate.placeholders.useCase": "예: 사내 평가 시스템, 채용 면접 평가, 연수 효과 측정 등",
  "quote.corporate.formNote": "전송해 주신 정보는 개인정보 보호정책에 따라 적절히 관리됩니다.",
  "quote.success.corporate.message": "요청해 주셔서 감사합니다. 담당자가 2영업일 이내에 연락드리겠습니다.",
  "quote.corporate.requirements.sso": "싱글 사인 온(SSO)",
  "quote.corporate.requirements.activeDirectory": "Active Directory 연동",
  "quote.corporate.requirements.customBranding": "커스텀 브랜딩",
  "quote.corporate.requirements.dedicatedServer": "전용 서버·온프레미스 도입",
  "quote.corporate.requirements.apiIntegration": "API 연동·커스텀 통합",
  "quote.corporate.requirements.auditLogs": "감사 로그·보안 기능",
  "quote.corporate.requirements.multilingual": "다국어 지원",
  "quote.corporate.requirements.support24": "24시간 지원",
  "quote.corporate.requirements.training": "도입 트레이닝·연수",
  "quote.corporate.requirements.dataMigration": "데이터 마이그레이션 지원",
  "quote.academic.subtitle": "학교·교육기관 대상",
  "quote.academic.description": "교육기관의 요구에 특화된 솔루션을 제안해 드립니다. 특별 가격 제공 및 교육 현장에 최적한 기능 커스터마이징도 가능합니다.",
  "quote.academic.sections.institutionInfo": "교육기관 정보",
  "quote.academic.fields.institutionName": "학교·기관명",
  "quote.academic.fields.institutionType": "기관 종별",
  "quote.academic.fields.department": "학부·학과·부서",
  "quote.academic.fields.positionTitle": "직책·직종",
  "quote.academic.fields.expectedUsers": "예상 이용자 수(교직원)",
  "quote.academic.fields.studentCount": "학생 수",
  "quote.academic.fields.currentSolution": "현재 평가 방법·시스템",
  "quote.academic.fields.budgetAnnual": "예산 범위(연간)",
  "quote.academic.institutionTypes.university": "대학교",
  "quote.academic.institutionTypes.college": "단기대학·전문학교",
  "quote.academic.institutionTypes.highSchool": "고등학교",
  "quote.academic.institutionTypes.juniorHigh": "중학교",
  "quote.academic.institutionTypes.elementary": "초등학교",
  "quote.academic.institutionTypes.vocational": "직업훈련학교",
  "quote.academic.userCounts.small": "5~20명",
  "quote.academic.userCounts.medium": "21~50명",
  "quote.academic.userCounts.large": "51~100명",
  "quote.academic.userCounts.xlarge": "101~300명",
  "quote.academic.userCounts.xxlarge": "301~500명",
  "quote.academic.userCounts.enterprise": "500명 이상",
  "quote.academic.studentCounts.under100": "100명 미만",
  "quote.academic.studentCounts.small": "100~500명",
  "quote.academic.studentCounts.medium": "501~1,000명",
  "quote.academic.studentCounts.large": "1,001~3,000명",
  "quote.academic.studentCounts.xlarge": "3,001~10,000명",
  "quote.academic.studentCounts.xxlarge": "10,000명 이상",
  "quote.academic.timeline.nextSemester": "다음 학기",
  "quote.academic.timeline.nextYear": "다음 년도",
  "quote.academic.budget.under1m": "100만원 미만",
  "quote.academic.budget.1m3m": "100~300만원",
  "quote.academic.budget.3m5m": "300~500만원",
  "quote.academic.budget.5m10m": "500~1,000만원",
  "quote.academic.budget.over10m": "1,000만원 이상",
  "quote.academic.placeholders.position": "예: 교수, 조교, 사무직원 등",
  "quote.academic.placeholders.useCase": "예: 학생 평가, 실습·실기 평가, 교원 연수, 수업 평가 등",
  "quote.academic.placeholders.currentSolution": "현재 사용 중인 평가 방법이나 시스템이 있다면 알려주세요",
  "quote.academic.placeholders.message": "교육기관 특유의 요청이나 질문이 있으시면 알려주세요",
  "quote.academic.formNote": "전송해 주신 정보는 개인정보 보호정책에 따라 적절히 관리됩니다.",
  "quote.success.academic.message": "요청해 주셔서 감사합니다. 교육기관 전문 담당자가 2영업일 이내에 연락드리겠습니다.",
  "quote.academic.requirements.lmsIntegration": "학습관리시스템(LMS) 연동",
  "quote.academic.requirements.gradeManagement": "성적관리시스템 연동",
  "quote.academic.requirements.studentPortal": "학생 포털 연동",
  "quote.academic.requirements.parentSharing": "학부모·보호자 공유 기능",
  "quote.academic.requirements.courseTemplates": "수업·실습용 템플릿",
  "quote.academic.requirements.learningAnalytics": "학습 분석·리포트 기능",
  "quote.academic.requirements.multilingualEng": "다국어 지원(영어 등)",
  "quote.academic.requirements.teacherTraining": "교원 대상 트레이닝",
  "quote.academic.requirements.implementationSupport": "도입 지원·연수",
  "common.backToDashboard": "대시보드로 돌아가기",

  // Report Generation
  "report.title": "성적표 출력",
  "report.evaluationNotice": "평가 통지표",
  "report.evaluationDate": "평가일",
  "report.criteriaEvaluation": "관점별 평가",
  "report.overallEvaluation": "종합 평가",
  "report.comments": "소견",
  "report.commentsPlaceholder": "상세 내용이나 코멘트를 입력하세요...",
  "report.commentsEmpty": "상세 내용이 입력되지 않았습니다",
  "report.editComments": "상세 내용 편집",
  "report.showPreview": "미리보기 표시",
  "report.hidePreview": "미리보기 숨기기",
  "report.preview": "미리보기",
  "report.criterionColumn": "관점",
  "report.gradeColumn": "등급",
  "report.rankColumn": "순위",
  "report.descriptionColumn": "기술",
  "report.nthGrade": "{{grade}}등급",
  "report.topPercentile": "상위 {{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "개인 평가",
  "report.groupAverage": "집단 평균",
  "report.summary": "요약",
  "report.enableOverallEvaluation": "종합 평가 활성화",
  "report.disableOverallEvaluation": "종합 평가 비활성화",
  "report.pointsFormat": "{{score}}점 / {{maxScore}}점",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "배점 설정",
  "report.footerNote": "※ 이 평가는 기준 준거 평가와 상대 평가를 병기하고 있습니다.",
  "report.rubricTitle": "평가 기준 (루브릭)",
  "report.noRubric": "루브릭이 생성되지 않았습니다",
  "report.noSubjects": "평가 대상이 등록되지 않았습니다.",
  "report.print": "인쇄",
  "report.downloadPdf": "PDF 다운로드",
  "report.downloadPdfLimitReached": "PDF 다운로드 (한도 달성)",
  "report.pdfExportLimit": "PDF 출력 한도(하루 {{count}}매)에 도달했습니다. {{planName}}으로 업그레이드하거나 내일 다시 시도해 주세요.",
  "report.pdfExportError": "PDF 출력을 할 수 없습니다.",
  "report.pdfGenerationFailed": "PDF 출력에 실패했습니다.",
  "report.pdfGenerationError": "PDF 생성 오류:",
  "report.reportCardNotFound": "성적표를 찾을 수 없습니다.",
  "report.pdfExportStatus": "오늘의 PDF 출력: {{current}}/{{max}}",
  "report.pdfExportRemaining": " (남은 {{remaining}}매)",
  "report.pdfExportLimitReached": "오늘의 출력 한도에 도달했습니다. {{planName}}에서 무제한 출력이 가능합니다.",
  "report.backToRubric": "루브릭 생성으로 돌아가기",
  "autoSave.unsaved": "저장되지 않음",
  "autoSave.savedSecondsAgo": "{{seconds}}초 전에 저장됨",
  "autoSave.savedMinutesAgo": "{{minutes}}분 전에 저장됨",
  "autoSave.savedAtTime": "{{time}}에 저장됨",
  "autoSave.saving": "저장 중...",
  "autoSave.unsavedChanges": "저장되지 않은 변경사항",
  "autoSave.autoSaveOn": "자동 저장: 켜짐",
  "plan.pro": "PRO",
  "billing.businessPrice": "₩25,000~",
  "billing.schoolPrice": "₩7,000~",
  "billing.pricePerMonth": "/월/인",

  // Steps
  "steps.process.ariaLabel": "평가 프로세스",
  "steps.productRegistration.title": "평가 대상 등록",
  "steps.productRegistration.description": "평가할 대상을 등록",
  "steps.criteriaExtraction.title": "관점 추출",
  "steps.criteriaExtraction.description": "AI로 평가 관점 추출",
  "steps.comparison.title": "비교 평가",
  "steps.comparison.description": "상대적으로 위치 지정",
  "steps.gradeAssignment.title": "등급 설정",
  "steps.gradeAssignment.description": "최종 평점 결정",
  "steps.rubricGeneration.title": "루브릭 생성",
  "steps.rubricGeneration.description": "AI로 루브릭 작성",
  "steps.quickEvaluation.title": "퀵 평가",
  "steps.quickEvaluation.description": "간단하게 평가 완성",
  "steps.reportGeneration.title": "성적표 출력",
  "steps.reportGeneration.description": "아름다운 통지표 생성",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "먼저 평가 대상을 등록해 주세요",
  "criteriaExtraction.emptyState.description": "관점을 추출하려면 먼저 평가 대상을 등록해야 합니다.",
  "criteriaExtraction.emptyState.backButton": "평가 대상 등록으로 돌아가기",
  "criteriaExtraction.title": "평가 관점 추출",
  "criteriaExtraction.description": "어떤 관점으로 평가하고 싶은지 설명해 주세요. AI가 자동으로 평가 관점을 추출합니다.",
  "criteriaExtraction.policyTitle": "평가 방침 및 중점 사항",
  "criteriaExtraction.policyDescription": "어떤 관점으로 평가하고 싶은지 구체적으로 설명해 주세요. AI가 최적의 평가 관점을 자동으로 추출합니다.",
  "criteriaExtraction.policyLabel": "평가 방침",
  "criteriaExtraction.policyPlaceholder": "예: 논리적 구성을 중시, 창의성과 독창성 평가, 실현 가능성에 초점 등",
  "criteriaExtraction.removePolicyTitle": "평가 방침 {{index}} 삭제",
  "criteriaExtraction.addPolicyButton": "평가 방침 추가",
  "criteriaExtraction.extractButton": "AI 관점 추출",
  "criteriaExtraction.extractingButton": "AI 추출 중...",
  "criteriaExtraction.extractedTitle": "추출된 평가 관점",
  "criteriaExtraction.extractedSubtitle": "{{count}}개의 평가 관점이 추출되었습니다. 내용을 확인하고 편집해 주세요.",
  "criteriaExtraction.addCriterionButton": "관점 수동 추가",
  "criteriaExtraction.newCriterionTitle": "새로운 관점",
  "criteriaExtraction.newCriterionDescription": "이 관점에 대해 평가합니다",
  "criteriaExtraction.generation.extracting": "평가 관점을 추출하고 있습니다...",
  "criteriaExtraction.generation.extractingDescription": "AI가 입력하신 내용을 분석하여 관련 평가 관점을 추출하고 있습니다.",
  "criteriaExtraction.successTitle": "관점 추출이 완료되었습니다!",
  "criteriaExtraction.successDescription": "각 관점의 내용을 확인하고 필요한 경우 편집한 후 다음 단계로 진행하세요.",
  "criteriaExtraction.nextButton": "비교 평가로",
  "criteriaExtraction.prevButton": "평가 대상 등록으로 돌아가기",

  // Product Registration
  "productRegistration.title": "평가 대상 등록",
  "productRegistration.description": "평가할 대상(학생 보고서, 제품, 제안서 등)을 등록하세요.",
  "productRegistration.securityNotice": "🔒 보안 모드가 활성화되어 있습니다. 대상 이름이 암호화됩니다.",
  "productRegistration.viewToggle.form": "폼",
  "productRegistration.viewToggle.formTitle": "폼 보기",
  "productRegistration.viewToggle.table": "표",
  "productRegistration.viewToggle.tableTitle": "표 보기",
  "productRegistration.import.drive": "Google Drive에서 가져오기",
  "productRegistration.import.driveTitle": "Google Drive에서 가져오기",
  "productRegistration.import.driveLabel": "Google Drive에서 파일 가져오기",
  "productRegistration.import.csv": "CSV 파일 업로드",
  "productRegistration.import.csvTitle": "CSV 파일 업로드",
  "productRegistration.import.csvLabel": "CSV 파일에서 평가 대상 업로드",
  "productRegistration.import.template": "CSV 템플릿 다운로드",
  "productRegistration.import.templateTitle": "CSV 템플릿 다운로드",
  "productRegistration.import.templateLabel": "CSV 템플릿 파일 다운로드",
  "productRegistration.import.driveDetail": "Google Drive에서 가져옴: {{fileName}}",
  "productRegistration.form.titleLabel": "평가 대상명",
  "productRegistration.form.titlePlaceholder": "예: 보고서 A, 기획안 B, 프로젝트 C",
  "productRegistration.form.titleHelp": "평가할 대상의 이름을 입력하세요",
  "productRegistration.form.linkLabel": "링크 (선택사항)",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... 등",
  "productRegistration.form.linkHelp": "관련 자료나 파일의 URL이 있으면 입력하세요",
  "productRegistration.form.detailLabel": "상세 정보 및 코멘트",
  "productRegistration.form.detailPlaceholder": "평가에 필요한 특징, 내용, 배경 정보 등의 세부사항을 입력하세요.\n예: \"졸업논문 초안, 경제학부 3학년이 작성한 지역 활성화 제안서\"",
  "productRegistration.form.detailHelp": "평가자가 적절히 평가할 수 있도록 내용과 특징에 대한 구체적인 세부사항을 제공해 주세요",
  "productRegistration.form.addButton": "평가 대상 추가",
  "productRegistration.list.title": "등록된 평가 대상 ({{count}}개)",
  "productRegistration.list.encryptedBadge": "🔒 암호화됨",
  "productRegistration.list.encrypted": "암호화되어 있습니다",
  "productRegistration.edit.titlePlaceholder": "평가 대상명 입력",
  "productRegistration.edit.linkPlaceholder": "링크 URL 입력",
  "productRegistration.edit.detailPlaceholder": "상세 정보 및 코멘트 입력",
  "productRegistration.edit.save": "저장",
  "productRegistration.edit.cancel": "취소",
  "productRegistration.preview": "{{title}} 미리보기",
  "productRegistration.edit": "{{title}} 편집",
  "productRegistration.delete": "{{title}} 삭제",
  "productRegistration.googleDrive.importedDetail": "Google Drive에서 가져옴: {{name}}",
  "productRegistration.csv.header1": "평가 대상명",
  "productRegistration.csv.detail1": "상세 설명",
  "productRegistration.csv.validationError": "CSV 파일에는 reviewTitle과 reviewComment 열이 필요합니다. 템플릿을 다운로드하여 확인하세요.",
  "productRegistration.error.encryptionFailed": "평가 대상명 암호화에 실패했습니다. 보안 설정을 확인하세요.",
  "productRegistration.navigation.next": "관점 추출로",
  "productRegistration.directRubric.title": "루브릭 직접 생성",
  "productRegistration.directRubric.description": "관점 추출을 건너뛰고 루브릭을 수동으로 생성할 수도 있습니다.",
  "productRegistration.directRubric.button": "수동 루브릭 생성으로 이동",
  "productRegistration.nextButton": "관점 추출로",
  "productRegistration.error.decryptionLog": "평가 대상 {{index}}의 복호화 오류:",
  "productRegistration.error.decryptionDisplay": "[복호화 오류]",
  "productRegistration.error.encryptionLog": "평가 대상명 암호화 오류:",
  "productRegistration.error.encryptionAlert": "평가 대상명 암호화에 실패했습니다. 보안 설정을 확인하세요.",
  "productRegistration.error.csvAlert": "CSV 파일에는 reviewTitle과 reviewComment 열이 필요합니다. 템플릿을 다운로드하여 확인하세요.",
  "productRegistration.csv.exampleTitle1": "평가 대상명1",
  "productRegistration.csv.exampleDetail1": "상세 설명1",
  "productRegistration.csv.exampleTitle2": "평가 대상명2",
  "productRegistration.csv.exampleDetail2": "상세 설명2",
  "productRegistration.csv.exampleTitle3": "평가 대상명3",
  "productRegistration.csv.exampleDetail3": "상세 설명3",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "먼저 평가 대상과 관점을 설정해 주세요",
  "comparisonEvaluation.emptyState.description": "비교 평가를 위해서는 평가 대상과 관점 모두가 필요합니다.",
  "comparisonEvaluation.emptyState.backToProducts": "평가 대상 등록으로 돌아가기",
  "comparisonEvaluation.emptyState.backToCriteria": "관점 추출로 돌아가기",
  "comparisonEvaluation.title": "몇 개를 좋은 순서대로 배열해 봅시다",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "평가 관점 선택",
  "comparisonEvaluation.productsPanel.title": "평가 대상",
  "comparisonEvaluation.productsPanel.hint": "드래그하여 수직선상에 배치하세요",
  "comparisonEvaluation.evaluationLine.low": "낮음",
  "comparisonEvaluation.evaluationLine.high": "높음",
  "comparisonEvaluation.evaluationLine.hint": "배치된 항목도 드래그하여 재배치할 수 있습니다",
  "comparisonEvaluation.progress.prefix": "진행률: ",
  "comparisonEvaluation.progress.suffix": " / {{total}}개 배치 완료",
  "comparisonEvaluation.progress.completed": "✅ 모든 평가가 완료되었습니다",
  "comparisonEvaluation.options.title": "배치 방법 선택",
  "comparisonEvaluation.options.description": "모든 항목을 한 번에 배치하거나 루브릭 생성 후 퀵 모드로 하나씩 배치할 수 있습니다.",
  "comparisonEvaluation.options.quickModeButton": "퀵 평가 모드 사용",
  "comparisonEvaluation.options.quickModeNote": "※ 루브릭 생성 후 하나씩 배치하는 간단한 모드",
  "comparisonEvaluation.nextButton": "등급 설정으로",
  "comparisonEvaluation.prevButton": "관점 추출로 돌아가기",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "평가를 완료해 주세요",
  "gradeAssignment.emptyState.description": "등급을 설정하려면 비교 평가가 완료되어야 합니다.",
  "gradeAssignment.emptyState.backButton": "비교 평가로 돌아가기",
  "gradeAssignment.title": "등급 설정",
  "gradeAssignment.description": "각 관점에 대해 등급 경계선을 드래그하여 조정하세요.",
  "gradeAssignment.criterionSelector.title": "관점 선택",
  "gradeAssignment.gradeSuffix": "등급",
  "gradeAssignment.gradeSettings.titleSuffix": " 등급 설정",
  "gradeAssignment.editGradesButton": "등급 편집",
  "gradeAssignment.boundaries.title": "등급 경계 조정",
  "gradeAssignment.boundaries.description": "경계선을 드래그하여 등급 범위를 조정하세요",
  "gradeAssignment.distribution.title": "등급 분포",
  "gradeAssignment.table.grade": "등급",
  "gradeAssignment.table.count": "인원",
  "gradeAssignment.table.percentage": "비율",
  "gradeAssignment.table.subjects": "평가 대상",
  "gradeAssignment.table.tooltip": "더블클릭으로 상세 내용 표시",
  "gradeAssignment.nextButton": "루브릭 생성으로",
  "gradeAssignment.prevButton": "비교 평가로 돌아가기",
  "gradeAssignment.modal.title": "등급 편집",
  "gradeAssignment.modal.gradeNamesTitle": "등급명 설정",
  "gradeAssignment.modal.gradeLabel": "등급 {{index}}",
  "gradeAssignment.modal.deleteButton": "삭제",
  "gradeAssignment.modal.addGradeButton": "등급 추가",
  "gradeAssignment.modal.doneButton": "완료",
  "gradeAssignment.status.notEvaluated": "미평가",
  "gradeAssignment.status.notSet": "미설정",
  "gradeAssignment.saveSuccess": "평가 데이터가 저장되었습니다!",
  "rubricGeneration.emptyState.title": "등급 설정을 완료해주세요",
  "rubricGeneration.emptyState.description": "루브릭 생성을 위해서는 등급 설정이 완료되어야 합니다.",
  "rubricGeneration.emptyState.backButton": "등급 설정으로 돌아가기",
  "rubricGeneration.title": "루브릭 생성",
  "rubricGeneration.description": "상위 작품들의 차이를 분석하여 상세한 루브릭을 작성합니다.",
  "rubricGeneration.progress.title": "등급 경계 차이 분석 진행률",
  "rubricGeneration.progress.criteriaComplete": "관점 완료",
  "rubricGeneration.progress.boundaryComplete": "경계 완료",
  "rubricGeneration.question.criterionLabel": "관점:",
  "rubricGeneration.question.gradeSuffix": "등급",
  "rubricGeneration.question.moreCount": "외 {{count}}개",
  "rubricGeneration.question.title": "\"{{criterion}}\"이라는 관점에서 {{upperGrade}}등급과 {{lowerGrade}}등급 작품에는 어떤 차이가 있다고 생각하셨나요?",
  "rubricGeneration.question.placeholder": "예: {{upperGrade}}등급 작품은 논리 구성이 명확하고 근거가 되는 데이터가 풍부하게 제시되어 있습니다. 반면 {{lowerGrade}}등급 작품은 논점은 좋지만 구체적인 예시가 부족하고 설득력이 떨어지는 부분이 있습니다.",
  "rubricGeneration.question.addButton": "차이 추가",
  "rubricGeneration.question.recordedDifferences": "기록된 차이:",
  "rubricGeneration.question.deleteButton": "삭제",
  "rubricGeneration.question.completeButton": "이 경계 분석 완료",
  "rubricGeneration.summary.title": "등급 경계 분석 결과 요약",
  "rubricGeneration.summary.boundaryTitle": "{{upperGrade}}·{{lowerGrade}} 경계",
  "rubricGeneration.summary.differencesCount": "{{count}}개의 차이 기록",
  "rubricGeneration.generation.generating": "루브릭 생성 중...",
  "rubricGeneration.generation.generateButton": "AI 루브릭 생성",
  "rubricGeneration.display.title": "생성된 루브릭",
  "rubricGeneration.display.description": "AI가 분석한 차이 정보로 작성된 상세한 루브릭입니다.",
  "rubricGeneration.display.regenerateButton": "재생성",
  "rubricGeneration.navigation.nextToQuick": "빠른 평가로",
  "rubricGeneration.navigation.backToGrade": "등급 설정으로 돌아가기",
  "rubricGeneration.error.generation": "루브릭 생성 중 오류가 발생했습니다",

  // Progress Bar
  "progressBar.label": "평가 진행률",
  "progressBar.messages.criteriaSetup": "관점을 설정하면 15% 완료됩니다",
  "progressBar.messages.completed": "🎉 평가가 완료되었습니다!",
  "progressBar.messages.progress": "평가 대상: {{products}}개 × 관점: {{criteria}}개 = {{total}}개 평가",

  // Evaluation Header
  "evaluationHeader.placeholder": "평가 제목을 입력해주세요",
  "evaluationHeader.saveTitle": "저장",
  "evaluationHeader.cancelTitle": "취소",
  "evaluationHeader.untitled": "제목 없는 평가",
  "evaluationHeader.editTitle": "제목 편집",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "상세: {{count}} 문자",
  "draggableProductCard.previewAvailable": "🔗 미리보기 가능",
  "draggableProductCard.showPreview": "미리보기 표시",
  "draggableProductCard.editDetails": "상세 편집",
  "draggableProductCard.position": "위치: {{value}}",
  "draggableProductCard.rank": "순위: {{value}}",
  "draggableProductCard.placed": "배치됨",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "빠른 평가 모드",
  "comparativeEvaluationQuick.criterionSelector.title": "평가 기준 선택",
  "comparativeEvaluationQuick.productsPanel.title": "평가 대상",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "현재 평가 중:",
  "comparativeEvaluationQuick.nextButton": "다음",
  "comparativeEvaluationQuick.prevButton": "이전",
  "comparativeEvaluationQuick.grades.excellent": "우수",
  "comparativeEvaluationQuick.grades.good": "양호",
  "comparativeEvaluationQuick.grades.average": "보통",
  "comparativeEvaluationQuick.grades.needsImprovement": "개선 필요",
  "comparativeEvaluationQuick.completion.title": "평가 완료",
  "comparativeEvaluationQuick.completion.subtitle": "{{count}}개 모든 평가가 완료되었습니다",
  "comparativeEvaluationQuick.completion.evaluationCount": "평가 건수",
  "comparativeEvaluationQuick.completion.criteriaCount": "평가 관점",
  "comparativeEvaluationQuick.completion.viewResults": "결과 확인",
  "comparativeEvaluationQuick.completion.detailAdjustment": "상세 조정",
  "comparativeEvaluationQuick.criterionComplete.title": "「{{criterion}}」완료",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}}개 평가가 완료되었습니다",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "다음 관점: ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "다음 관점으로 진행",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "모든 관점의 평가가 완료되었습니다",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "결과 확인",
  "comparativeEvaluationQuick.empty.title": "평가할 데이터가 없습니다",
  "comparativeEvaluationQuick.empty.description": "제품과 평가 기준을 설정해주세요.",
  "comparativeEvaluationQuick.header.doubleClickToView": "더블클릭으로 상세 보기",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} 완료",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} 관점)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "다음 관점: {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "남은 {{count}}개",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "왼쪽(D: 개선 필요)에서 오른쪽(A: 우수)까지 평가하고 싶은 위치를 클릭해주세요.",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " 현재 위치: {{grade}} ({{description}})",
  "comparativeEvaluationQuick.actions.switchToAllMode": "전체 배치 모드로 전환",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Enter 키로 다음 관점으로 진행",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "스페이스 키로 다음 관점 건너뛰기",
  "comparativeEvaluationQuick.criterion.instruction": "이 관점에서 우열을 판단해 주세요",

  // Grade Assignment
  "gradeAssignment.modal.gradePlaceholder": "등급명을 입력하세요",
  "gradeAssignment.boundaryLabel": "{{upper}}・{{lower}} 경계",
  "gradeAssignment.doubleClickToView": "더블 클릭으로 상세 보기",
  "gradeAssignment.dragBoundaryHint": "경계선을 드래그하여 등급 범위를 조정할 수 있습니다",
  "gradeAssignment.percentAbove": "{{percent}}% 이상이 {{grade}}",
  "gradeAssignment.gradeNumber": "등급{{number}}",
  "gradeAssignment.grade": "등급",

  // Evaluation Page
  "evaluation.noDataToSave": "저장할 데이터가 없습니다",
  "evaluation.dataSaved": "데이터가 정상적으로 저장되었습니다!",
  "evaluation.saveFailed": "저장에 실패했습니다",
  "evaluation.saveError": "저장 중 오류가 발생했습니다",
  "evaluation.failedKeyword": "실패",
  "evaluation.errorKeyword": "오류",
  "evaluation.saving": "💾 저장 중...",

  // Product Registration
  "productRegistration.registeredItems": "등록된 평가 대상 ({{count}}개)",
  "productRegistration.encryptedBadge": "🔒 암호화됨",
  "productRegistration.encryptedTitle": "암호화되었습니다",
  "productRegistration.previewTitle": "{{title}} 미리보기",
  "productRegistration.editTitle": "{{title}} 편집",
  "productRegistration.deleteTitle": "{{title}} 삭제",

  // CSV Export
  "csvExport.export": "CSV 내보내기",
  
  // Missing translations
  "evaluation.loadError": "프로젝트를 불러오지 못했습니다",
  "evaluation.loadingProject": "프로젝트를 불러오는 중...",
  
  // Invitation page
  "invitation.invalidOrExpired": "유효하지 않거나 만료된 초대",
  "invitation.invalidTitle": "유효하지 않은 초대",
  "invitation.invalidDescription": "이 초대 링크는 유효하지 않습니다.",
  "invitation.backToDashboard": "대시보드로 돌아가기",
  "invitation.acceptedTitle": "초대 수락됨",
  "invitation.acceptedDescription": "협업에 성공적으로 참여했습니다.",
  "invitation.redirecting": "대시보드로 리다이렉트 중...",
  "invitation.goToDashboard": "대시보드로 이동",
  "invitation.description": "프로젝트 협업 초대를 받았습니다.",
  "invitation.acceptQuestion": "이 초대를 수락하시겠습니까?",
  "invitation.processing": "처리 중...",
  "invitation.decline": "거절",
  "invitation.capabilitiesTitle": "협업자 권한",
  "invitation.capability1": "프로젝트 보기 및 편집",
  "invitation.capability2": "평가 수행 및 수정",
  "invitation.capability3": "보고서 생성 및 내보내기",
  "invitation.capability4": "다른 멤버 초대",
  "invitation.capability5": "프로젝트 설정 변경",
  
  // RubricGeneration
  "rubricGeneration.generation.generatingDescription": "최적의 평가 루브릭을 생성하기 위해 기준과 제품을 분석 중...",
  "rubricGeneration.generation.step1": "평가 기준 분석",
  "rubricGeneration.generation.step2": "제품 특성 분석",
  "rubricGeneration.generation.step3": "평가 루브릭 생성",
  "rubricGeneration.criterionSelector.title": "기준 선택",
  "rubricGeneration.display.editCellAria": "셀 편집",
  
  // Report
  "report.noRubricDescriptions": "루브릭 설명이 없습니다",
  "report.commentGenerationFailed": "코멘트 생성 실패",
  "report.allEvaluations": "전체 평가",
  "preview.openInNewTab": "새 탭에서 열기",
  "report.generateComment": "코멘트 생성",
  "report.pdfGeneration.generating": "PDF 생성",
  "report.pdfGeneration.generatingDescription": "모든 제품에 대한 PDF 보고서 생성 중...",
  "report.pdfGeneration.step1": "평가 데이터 수집",
  "report.pdfGeneration.step2": "PDF 레이아웃 생성",
  "report.pdfGeneration.step3": "보고서 완성",
  "report.generatingPdf": "PDF 생성 중...",
  "report.downloadAllPdf": "모든 PDF 다운로드",
  "report.backToQuick": "빠른 평가로 돌아가기",
  "report.generatingPdfDescription": "PDF 보고서를 생성 중입니다. 잠시 기다려 주세요...",
  "report.pdfStep1": "평가 데이터 수집",
  "report.pdfStep2": "PDF 레이아웃 생성",
  "report.pdfStep3": "보고서 완성",
  
  // Product Registration
  "productRegistration.error.encryptionError": "암호화 오류가 발생했습니다",
  "productRegistration.quickInput.placeholder": "제품명 또는 세부사항 입력 (한 줄에 하나씩)",
  "productRegistration.quickInput.hint": "여러 항목을 한 번에 붙여넣을 수 있습니다. 빈 줄은 무시됩니다.",
  "productRegistration.quickInput.disable": "상세 입력 모드로 전환",
  "productRegistration.quickInput.enable": "빠른 입력 모드로 전환",
  "productRegistration.mode.detailed": "상세 모드",
  "productRegistration.mode.quick": "빠른 모드",
  "productRegistration.quickInput.collectDetails": "세부사항 수집",
  "productRegistration.emptyHint": "진행하려면 최소 하나의 제품을 추가하세요",
  "productRegistration.form.modalTitle": "제품 편집",
  
  // Grade Assignment
  "gradeAssignment.distribution.doubleClickToView": "더블클릭하여 상세보기",
  
  // Criteria Extraction
  "criteriaExtraction.inputFormTitle": "평가 기준 입력",
  "criteriaExtraction.inputFormSubtitle": "평가에 사용할 기준을 입력하세요",
  "criteriaExtraction.productDescriptionsLabel": "제품 설명",
  "criteriaExtraction.productDescriptionPlaceholder": "제품 설명을 입력하세요...",
  "criteriaExtraction.removeDescription": "설명 제거",
  "criteriaExtraction.criteriaListTitle": "평가 기준 목록",
  "criteriaExtraction.criterionTitlePlaceholder": "기준 제목을 입력하세요",
  "criteriaExtraction.criterionDescriptionPlaceholder": "기준 설명을 입력하세요",
  "criteriaExtraction.addCriterionCard": "새 기준 추가",
  "criteriaExtraction.editCriterion": "기준 편집",
  "criteriaExtraction.deleteCriterion": "기준 삭제",
  "criteriaExtraction.extracting": "기준 추출 중",
  "criteriaExtraction.extractingDescription": "평가 기준을 추출하기 위해 입력 내용을 분석 중...",
  "criteriaExtraction.step1": "내용 분석",
  "criteriaExtraction.step2": "주요 기준 식별",
  "criteriaExtraction.step3": "결과 정리",
  "criteriaExtraction.quickInputPlaceholder": "평가 기준을 입력하거나 기준을 추출할 내용을 붙여넣으세요...",
  "criteriaExtraction.addCriterionModalTitle": "새 기준 추가",
  "criteriaExtraction.criterionTitleLabel": "기준 제목",
  "criteriaExtraction.criterionDescriptionsLabel": "기준 설명",
  "criteriaExtraction.removeCriterionDescription": "설명 제거",
  "criteriaExtraction.addCriterionDescriptionButton": "설명 추가",
  "criteriaExtraction.addCriterionConfirmButton": "기준 추가",
  
  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.cursor.nextStep": "다음 단계로 진행",
  "comparativeEvaluationQuick.cursor.nextCriterion": "다음 기준으로 진행",
  
  // Preview
  "preview.loadErrorDetail": "미리보기를 불러오지 못했습니다",
  "preview.invalidUrl": "유효하지 않은 URL",
  "preview.invalidUrlDetail": "유효한 URL을 입력해주세요",
  "preview.loading": "로딩 중...",
  "preview.loadError": "불러오기 실패",
  "preview.pageLoadError": "페이지를 불러오지 못했습니다",
  "preview.comment": "코멘트",
  "preview.commentPlaceholder": "코멘트를 추가하세요...",
  
  // Google Drive
  "googleDrive.searchPlaceholder": "파일 검색...",
  "googleDrive.allTypes": "모든 유형",
  "googleDrive.documents": "문서",
  "googleDrive.spreadsheets": "스프레드시트",
  "googleDrive.presentations": "프레젠테이션",
  "googleDrive.sortByName": "이름",
  "googleDrive.sortByModified": "수정일",
  "googleDrive.searchResults": "\"{{query}}\" 검색 결과",
  "googleDrive.selectAll": "모두 선택",
  "googleDrive.clearSelection": "선택 해제",
  "common.folder": "폴더",
  "googleDrive.noSearchResults": "검색 결과가 없습니다",
  
  // Dashboard
  "dashboard.enterProjectName": "프로젝트 이름 입력",
  
  // AutoSave
  "autoSave.enable": "자동 저장 활성화",
  "autoSave.currentSetting": "현재 설정:",
  "autoSave.descriptionShort": "데이터가 자동으로 저장됩니다",
  "autoSave.descriptionLocal": "로컬 스토리지에도 저장됩니다",
  "autoSave.descriptionError": "오류 시 데이터가 보존됩니다",
  
  // Weight
  "weight.currentTotal": "현재 합계:",
  
  // CSV Export
  "csvExport.templateRequired": "템플릿을 입력해주세요",
  "csvExport.exportFailed": "내보내기 실패",
  "csvExport.sampleComment": "이것은 샘플 코멘트입니다",
  "csvExport.currentUser": "현재 사용자",
  "csvExport.title": "CSV 내보내기",
  "csvExport.exportStatus": "내보내기 상태",
  "csvExport.remaining": "남은 횟수:",
  "csvExport.unlimited": "무제한",
  "csvExport.templateLabel": "내보내기 템플릿",
  "csvExport.templatePlaceholder": "템플릿을 입력하세요...",
  "csvExport.templateHelp": "사용 가능한 변수를 사용하여 템플릿을 작성하세요",
  "csvExport.availablePlaceholders": "사용 가능한 변수",
  "csvExport.preview": "미리보기",
  "csvExport.filename": "파일명",
  "csvExport.format": "형식",
  "csvExport.includeHeader": "헤더 포함",
  "csvExport.exporting": "내보내는 중...",
  
  // Rubric Generation Dialog
  "rubricGeneration.differenceDialog.title": "차이점 설명",
  "rubricGeneration.differenceDialog.progress": "{{total}}개 중 {{current}}번째 질문",
  "rubricGeneration.differenceDialog.question": "{{criterion}}에서 \"{{gradeA}}\"와 \"{{gradeB}}\"의 차이점은 무엇인가요?",
  "rubricGeneration.differenceDialog.hint": "이 평가 수준들 간의 구체적인 차이점을 설명해주세요.",
  "rubricGeneration.differenceDialog.placeholder": "예: 레벨 A는 완전한 이해를 보여주는 반면 레벨 B는 부분적 이해를 보여줍니다...",
  "rubricGeneration.differenceDialog.skipAndGenerate": "건너뛰고 생성",
  "rubricGeneration.differenceDialog.skip": "건너뛰기",
  "rubricGeneration.differenceDialog.completeAndGenerate": "완료하고 생성",
  "rubricGeneration.differenceDialog.next": "다음",
  
  // Product Registration
  "productRegistration.noDetailProvided": "제공된 세부사항 없음",
  "productRegistration.detailsDialog.title": "제품 세부사항",
  "productRegistration.detailsDialog.progress": "{{total}}개 중 {{current}}번째 제품",
  "productRegistration.detailsDialog.productTitle": "{{title}}",
  "productRegistration.detailsDialog.detailLabel": "세부사항",
  "productRegistration.detailsDialog.detailPlaceholder": "제품 세부사항 또는 설명을 입력하세요...",
  "productRegistration.detailsDialog.linkLabel": "참조 링크 (선택사항)",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com/product",
  "productRegistration.detailsDialog.hint": "평가에 도움이 되는 세부사항을 제공하세요. 필요하지 않으면 건너뛸 수 있습니다.",
  "productRegistration.detailsDialog.skipAndComplete": "모두 건너뛰고 완료",
  "productRegistration.detailsDialog.skip": "건너뛰기",
  "productRegistration.detailsDialog.complete": "완료",
  "productRegistration.detailsDialog.next": "다음",
  "productRegistration.edit.modalTitle": "제품 편집",
  
  // Criteria Extraction Modal
  "criteriaExtraction.edit.modalTitle": "기준 편집",
  "criteriaExtraction.form.titleLabel": "제목",
  "criteriaExtraction.edit.titlePlaceholder": "기준 제목을 입력하세요",
  "criteriaExtraction.form.descriptionLabel": "설명",
  "criteriaExtraction.edit.descriptionPlaceholder": "기준 설명을 입력하세요",
  "criteriaExtraction.form.addDescription": "설명 추가",
  "criteriaExtraction.edit.save": "저장",
  "criteriaExtraction.edit.cancel": "취소",
  
  // Grade Assignment
  "gradeAssignment.dragOrDoubleClick": "경계선을 드래그하거나 제품을 더블클릭하여 조정하세요",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "가져오기",
  "productRegistration.import.googleDrive": "구글 드라이브",
  "productRegistration.import.localTitle": "로컬 파일에서 가져오기",
  "productRegistration.import.localLabel": "로컬 파일에서 가져오기",
  "productRegistration.import.local": "로컬 파일",
  
  // Missing error messages
  "productTable.error.invalidInput": "유효한 평가 대상이 입력되지 않았습니다.",
  "productTable.error.encryptionFailed": "「{{title}}」의 암호화에 실패했습니다.",
  "productTable.success.addedItems": "{{count}}개의 평가 대상을 추가했습니다.",
  "productTable.error.addingItems": "평가 대상 추가 중 오류가 발생했습니다.",
  "productDetail.error.encryptionFailed": "암호화에 실패했습니다. 보안 설정을 확인하세요.",
  "share.error.settingsFailed": "공유 설정 변경에 실패했습니다",
  "share.success.linkGenerated": "초대 링크를 생성했습니다",
  "share.error.linkGenerationFailed": "초대 링크 생성에 실패했습니다",
  "share.success.linkCopied": "초대 링크를 클립보드에 복사했습니다",
  "share.error.copyFailed": "복사에 실패했습니다",
  "share.success.invitationSent": "초대를 전송했습니다",
  "share.error.invitationFailed": "초대 전송에 실패했습니다",
  "collaboration.success.invitationSent": "초대를 전송했습니다",
  "collaboration.error.invitationFailed": "초대 전송에 실패했습니다",
  "collaboration.success.collaboratorRemoved": "공동 작업자를 삭제했습니다",
  "collaboration.error.removalFailed": "삭제에 실패했습니다",
  "error.encryptionError": "암호화 오류",
  "error.decryptionError": "복호화 오류",
  "error.localFileProcessError": "로컬 파일 처리 오류",
  "error.googleDriveImportError": "구글 드라이브 가져오기 오류",
  "error.csvParseError": "CSV 파싱 오류",
  
  // LocalFolderBrowser translations
  "localFolderBrowser.title": "로컬 파일 선택",
  "localFolderBrowser.searchPlaceholder": "파일명으로 검색",
  "localFolderBrowser.selectFolder": "폴더 선택",
  "localFolderBrowser.loading": "파일을 불러오는 중...",
  "localFolderBrowser.loadingWithFile": "불러오는 중: {{filename}} ({{current}}/{{total}})",
  "localFolderBrowser.dropMessage": "폴더를 드래그 & 드롭하세요",
  "localFolderBrowser.dropMessageOr": "또는 「폴더 선택」을 클릭하세요",
  "localFolderBrowser.selectAll": "전체 선택 ({{selected}}/{{total}})",
  "localFolderBrowser.filesTotal": "전체: {{count}} 파일",
  "localFolderBrowser.filesSelected": "선택: {{count}} 파일",
  "localFolderBrowser.select": "선택 ({{count}})",
  "localFolderBrowser.preview": "미리보기",
  "localFolderBrowser.fileTypeNotSupported": "이 파일 형식은 미리볼 수 없습니다",
  
  // Menu item
  "menu.colorPalette": "색상 팔레트",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "내보내기",
  "productRegistration.export.template": "템플릿",
  "localFolderBrowser.noFilesFound": "파일을 찾을 수 없습니다",
  "localFolderBrowser.dropzone.text": "파일을 드래그 앤 드롭하거나 클릭하여 선택",
  "localFolderBrowser.dropzone.acceptedFormats": "지원 형식: .txt, .csv, .docx, .pdf, .xlsx",
  "localFolderBrowser.cancel": "취소",
  "localFolderBrowser.import": "가져오기",
  
  // Evaluation page missing translations
  "evaluation.currentDataRetained": " - 현재 데이터가 유지됩니다",
  "evaluation.unknownError": "알 수 없는 오류",
  "evaluation.dataRetained": " - 데이터가 유지됩니다",
  "evaluation.errorOccurred": "오류가 발생했습니다: ",
  
  // Evaluation guidance messages
  "evaluation.guidance.registerProducts": " 평가할 제품을 등록해 주세요",
  "evaluation.guidance.completeRegistration": " 제품 등록을 완료하고 '다음'을 클릭하세요",
  "evaluation.guidance.extractCriteria": " 평가 기준을 추출하거나 수동으로 추가해 주세요",
  "evaluation.guidance.confirmCriteria": " 기준을 검토 및 편집하고 '다음'을 클릭하세요",
  "evaluation.guidance.placeProducts": "💡 각 기준별로 최소 {{count}}개의 제품을 배치하세요",
  "evaluation.guidance.placeMoreProducts": "💡 '{{criterionTitle}}' 기준에 {{remaining}}개의 제품을 더 배치하세요",
  "evaluation.guidance.comparisonComplete": " 필수 비교가 완료되었습니다. '다음'을 클릭하여 등급 할당으로 진행하세요",
  "evaluation.guidance.setGrades": "💡 '{{criterionTitle}}'에 대한 등급(A, B, C 등)을 설정해 주세요",
  "evaluation.guidance.gradesComplete": " 등급 할당이 완료되었습니다. '다음'을 클릭하여 루브릭을 생성하세요",
  "evaluation.guidance.rubricGenerated": " 루브릭이 생성되었습니다. '다음'을 클릭하여 진행하세요",
  "evaluation.guidance.generateRubric": " 루브릭을 생성해 주세요",
  "evaluation.guidance.startEvaluation": "💡 평가를 시작해 봅시다! 클릭하여 항목을 배치하세요",
  "evaluation.guidance.progress25": "💡 좋은 진행률입니다! 거의 절반에 왔습니다 ({{progress}}% 완료)",
  "evaluation.guidance.progress50": "💡 절반을 넘었습니다! 계속해주세요 ({{progress}}% 완료)",
  "evaluation.guidance.progress75": "💡 75% 완료! 마무리가 보입니다",
  "evaluation.guidance.almostDone": "💡 거의 다 왔습니다! {{unplacedCount}}개 항목만 남았습니다",
  "evaluation.guidance.allComplete": " 모든 평가가 완료되었습니다. '다음'을 클릭하여 보고서를 생성하세요",
  "evaluation.guidance.downloadReport": " 보고서를 다운로드하거나 공유해 주세요",
  
  // Evaluation reminder messages
  "evaluation.reminder.continuePlacing": "💭 '{{criterionTitle}}' 기준에 대해 제품 배치를 계속하세요 ({{remaining}}개 남음)",
  "evaluation.reminder.almostHalf": "💭 '{{criterionTitle}}' 평가를 계속해 봅시다. 거의 절반이에요!",
  "evaluation.reminder.overHalf": "💭 '{{criterionTitle}}' 평가 중 - 절반 이상 완료!",
  "evaluation.reminder.fewLeft": "💭 '{{criterionTitle}}' - 몇 개만 더 남았어요!",
  
  // Security and layout messages
  "security.modeEnabled": "보안 모드 활성화됨",
  "msg.welcomeWithName": "환영합니다, {{name}}님",
  "footer.privacyPolicy": "개인정보 처리방침",
  "footer.termsOfService": "이용약관"
};